import * as React from 'react';
import { ThemeContext } from 'styled-components';

/**
 * _Danger: This hook is for consumer use and shouldn't be used within BlockParty Components.
 * Please use `themeGet()` from `@styled-system/theme-get` instead.
 */
/**
 * `useTheme` is a custom hook that retreives the theme object from context. It is very useful when
grabbing values from dynamic themes.
 *
 */
const useTheme = () => {
  const context = React.useContext(ThemeContext);
  if (!context) {
    throw new Error('[useThemeHook]: must be used within the BlockPartyProvider');
  }
  return context;
};

export { useTheme };
